import { defineStore } from "pinia";
import apiClient from "@/axiosConfig";
import { useUserStore } from "@/stores/userStore";

export const useCompanyFeatureStore = defineStore("companyFeatures", {
  state: () => ({ companyId: null, features: {}, loaded: false, requestVersion: 0 }),
  getters: {
    isEnabled: (state) => (featureId) => state.loaded && Boolean(state.features[featureId]),
  },
  actions: {
    clear() {
      this.requestVersion += 1;
      this.companyId = null;
      this.features = {};
      this.loaded = false;
    },
    async loadFeatures() {
      const companyId = useUserStore().currentCompanyId;
      this.clear();
      const requestVersion = this.requestVersion;
      if (!companyId) return;
      const response = await apiClient.get("/company-features/current");
      if (this.requestVersion !== requestVersion || useUserStore().currentCompanyId !== companyId
        || response?.data?.companyId !== companyId) return;
      this.companyId = companyId;
      this.features = Object.fromEntries((response.data.features || []).map((item) => [item.featureId, item.enabled]));
      this.loaded = true;
    },
  },
});
